import { memo } from 'react';
import * as S from './CardImage.styles';

type CardImageProps = {
    imageSrc: string;
    title: string;
};

const CardImageContainer = ({ imageSrc, title }: CardImageProps) => {
    return (
        <S.ImgWrap>
            <S.Gradient />
            <S.Image src={imageSrc} alt={title} loading="lazy" width="325" height="240" />
        </S.ImgWrap>
    );
};

export const CardImage = memo(CardImageContainer);
